import { RouteConfig } from "vue-router"
import DashView from "@/components/layout/Dash.vue"
import { ROLES } from "../../../constants/roles"

const setupPermissions =
    process.env.NODE_ENV === "development" ? [ROLES.USER, ROLES.ADMIN] : [ROLES.USER]

export const setupRoutes: RouteConfig[] = [
    {
        path: "/setup",
        component: DashView,
        meta: { title: "Setup", permissions: setupPermissions, requiresAuth: true },
        children: [
            {
                path: "",
                name: "Setup",
                component: () => import("@/views/setup/SetupPage.vue"),
                meta: {
                    title: "Setup",
                    isContextSource: true,
                    permissions: setupPermissions,
                    requiresAuth: true,
                    type: "setup",
                },
            },
            {
                path: "devices",
                name: "DevicesSetup",
                component: () => import("@/views/setup/DevicesSetupPage.vue"),
                meta: { title: "Devices", permissions: setupPermissions, requiresAuth: true },
            },
        ],
    },
]
